<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['order.no']" placeholder="business.label.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['orderType.name']" :editable="false" placeholder="business.label.orderType" @clear="onOrderTypeChange([])" @click="onOrderTypeSelect"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="asnOrder.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="asnOrder.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="asnOrder.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="asnDetail.quantity" title="business.label.quantity"/>
        <vxe-column field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity"/>
        <vxe-column field="asnDetail.rejectedQuantity" title="business.label.rejectedQuantity"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.detail" icon="vxe-icon-association-form" status="primary" @click.stop="getDetail(row)"/>
            <vxe-button content="button.close" icon="vxe-icon-close" status="danger" @click.stop="close(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <order-type-modal ref="orderTypeModal" @change="onOrderTypeChange"/>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'

export default {
  name: 'ReceivingCloseTable',
  components: { OrderTypeModal },
  props: {
    orderStatus: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'order.no': '',
        'orderType.id': null,
        'orderType.name': ''
      }
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    onOrderTypeSelect() {
      this.$refs.orderTypeModal.open({ available: true, operationType: 1, refundable: false })
    },
    onOrderTypeChange(values) {
      if (values.length > 0) {
        this.query['orderType.id'] = values[0].id
        this.query['orderType.name'] = values[0].name
      } else {
        this.query['orderType.id'] = null
        this.query['orderType.name'] = ''
      }
      this.refresh()
    },
    fetch() {
      this.loading = true
      findAll('receivingCloseListFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'order.no': '',
        'orderType.id': null,
        'orderType.name': ''
      }
      this.refresh()
    },
    getDetail(row) {
      this.$emit('getDetail', row)
    },
    close(row) {
      const that = this
      this.$confirm({
        title: '是否确认关单?',
        content: '关单之后单据将无法继续收货以及验收',
        onOk() {
          that.loading = true
          post(api.receivingAsnCompleteAll, { type: 'normalAsn' }, { id: row.asnOrder.id }).then(res => {
            if (res.success) {
              that.fetch()
              that.$message.success(that.$t('message.operationSuccess'))
            }
          }).finally(() => that.loading = false)
        },
        onCancel() {
        },
        centered: true
      })
    }
  }
}
</script>